module.exports = __webpack_public_path__ + "img/Amphibi.7242c627.jpg";